export default{
	dashboard : {
		my_asset : 'Total of my asset',
		this_month : 'Total of tools that are due for service this month',
		this_week : 'Total of tools that are due for service this week',
		overdue : 'Total of tools that have past the service date and no action has been taken',
	},
	my_assets : {
		status : "Status assets\n 1. BUSY : Assets is used by someone\n 2. IDLE : Assets is ready to use or booking\n 3. BROKEN : Assets is broken, need to repair or maintenance\n 4. LOST : Assets is lost from system\n 5. REPAIRING : Assets is being repair by contractor",
	},
	booking_assets : {
		status : 'Status booking assets\n 1. Confirmed : Booking assets is confirm by admin and ready to use\n 2. Waiting : Booking assets is waiting to response from user/admin\n 3. Ongoing : Assets is used till due date\n 4. Reassign : Assets is reasign to another user',
	},
	all_asset:{
		status : "Status assets\n 1. BUSY : Assets is used by someone\n 2. IDLE : Assets is ready to use or booking\n 3. BROKEN : Assets is broken, need to repair or maintenance\n 4. LOST : Assets is lost from system\n 5. REPAIRING : Assets is being repair by contractor",
		maintenance : 'Assets Condition for maintenance\n 1. Green : Assets in good status and ready to use or booking\n 2. Yellow : Assets need to Maintanance ASAP\n 3. Red : Assets need to maintenance imediately',
	},
	job_siteinformation:{
		status : "Status assets\n 1. BUSY : Assets is used by someone\n 2. IDLE : Assets is ready to use or booking\n 3. BROKEN : Assets is broken, need to repair or maintenance\n 4. LOST : Assets is lost from system\n 5. REPAIRING : Assets is being repair by contractor",
		maintenance : 'Assets Condition for maintenance\n 1. Green : Assets in good status and ready to use or booking\n 2. Yellow : Assets need to Maintanance ASAP\n 3. Red : Assets need to maintenance imediately',
	},
	admin_addedit:{
		status : "Status assets\n 1. BUSY : Assets is used by someone\n 2. IDLE : Assets is ready to use or booking\n 3. BROKEN : Assets is broken, need to repair or maintenance\n 4. LOST : Assets is lost from system\n 5. REPAIRING : Assets is being repair by contractor",
	},
	// on edit asset
	asset_detail :{
		max_day : 'Default max day for rent',
		status : 'Status Assets',
		make : 'This asset made in from',
	},
	admin_addregistration :{
		max_day : 'Default max day for rent',
		status : 'Status Assets',
		make : 'This asset made in from',
	},
	admin_bookinglist : {
		status : 'Status booking assets\n 1. Done : Booking assets is done\n 2. Waiting : Booking assets is waiting to response from user/admin\n 3. Ongoing : Assets is used till due date\n 4. Reassign : Assets is reasign to another user\n 5. Confirmed : Booking assets is confirm by admin and ready to use\n 6. Canceled: Booking assets is canceled by user',
	},
	setting_site : {
		status : 'Site status',
	},
	setting_user : {
		status : 'User login status',
	},
	tenant_setting :{
		max_day : 'Insert default max day for rent',
		urgency_day : 'Input urgency day when item is...',
		coverage_city : 'is coverage_city ?',
		status : 'Status Assets',
		default_value : 'Default values setting within application.',
		site_mapping : 'Predefining site type as Storage and Maintanance site.',
		status_mapping : 'Predefining site status as Inavtive site',
		asset_mapping : 'Predefining Asset Status within system automation.',
		role_mapping : 'Predefining role as Admin and Storage role.',
		custom_branding : 'Setting custom branding logo for your apps.',
	},
}


// Old One

/*
export default{
	dashboard : {
		my_asset : 'Total of my asset',
		this_month : 'Total of tools that are due for service this month',
		this_week : 'Total of tools that are due for service this week',
		overdue : 'Total of tools that have past the service date and no action has been taken',
	},
	my_assets : {
		status : 'Status assets',
	},
	booking_assets : {
		status : 'Status booking assets',
	},
	all_asset:{
		status : 'Status Assets',
		maintenance : 'Assets Condition for maintenance',
	},
	job_siteinformation:{
		status : 'Status Assets',
		maintenance : 'Assets Condition for maintenance',
	},
	admin_addedit:{
		status : 'Status Assets',
	},
	// on edit asset
	asset_detail :{
		max_day : 'Default max day for rent',
		status : 'Status Assets',
		make : 'This asset made in from',
	},
	admin_addregistration :{
		max_day : 'Default max day for rent',
		status : 'Status Assets',
		make : 'This asset made in from',
	},
	admin_bookinglist : {
		status : 'Status booking assets',
	},
	setting_site : {
		status : 'Site status',
	},
	setting_user : {
		status : 'User login status',
	},
	tenant_setting :{
		max_day : 'Insert default max day for rent',
		urgency_day : 'Input urgency day when item is...',
		coverage_city : 'is coverage_city ?',
		status : 'Status Assets',
		default_value : 'Default values setting within application.',
		site_mapping : 'Predefining site type as Storage and Maintanance site.',
		status_mapping : 'Predefining site status as Inavtive site',
		asset_mapping : 'Predefining Asset Status within system automation.',
		role_mapping : 'Predefining role as Admin and Storage role.',
		custom_branding : 'Setting custom branding logo for your apps.',
	},
}
*/


// WEBPACK FOOTER //
// ./src/App/config/language.js